import { render } from "./WhatsappConfigModal.vue?vue&type=template&id=36881494&scoped=true"
import script from "./WhatsappConfigModal.vue?vue&type=script&lang=js"
export * from "./WhatsappConfigModal.vue?vue&type=script&lang=js"

import "./WhatsappConfigModal.vue?vue&type=style&index=0&id=36881494&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36881494"]])

export default __exports__